export default "__VITE_ASSET__8553503f__"